<template>
  <div class="flex flex-col items-center mb-10">
    <p class="text-sm text-neutral-500">Build: {{ buildVersion }}</p>
  </div>
</template>
<script setup>
import { config } from "@/config";
const buildVersion = config.VERSION;
</script>
